import { useEffect } from "react";
import { Badge, Button, Card, Col, Container, Form, Row, } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchCurrentPlanFeatures } from "../store/plansSlice";

const CurrentPlanBlock = ({ tenantId }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const { accessToken } = useSelector((state) => state.auth);
  const { currentPlan } = useSelector((state) => state.plans);
  const currentTenant = useSelector((state) => state?.sharedSlice?.currentTenant);
  const productLabel = (currentTenant?.flavor || "")
    ? (currentTenant.flavor === "fitplusclub"
        ? "Fitplusclub"
        : currentTenant.flavor === "billplus"
        ? "Billplus"
        : currentTenant.flavor)
    : "";

  const normalizeName = (v) =>
    (typeof v === "string" ? v : v?.name || "").toLowerCase();
  const planFeaturesList = Array.isArray(currentPlan?.features)
    ? currentPlan.features
    : Array.isArray(currentPlan?.plan?.features)
    ? currentPlan.plan.features
    : [];
  const hasDesktopAccess = planFeaturesList.some(
    (f) => normalizeName(f) === "desktop_app"
  );

  const expiresAt = currentPlan?.subscription?.expires_at;
  let expiryLabel = null;
  let expiryDisplay = null;
  if (expiresAt) {
    const expiryDate = new Date(expiresAt);
    if (!isNaN(expiryDate.getTime())) {
      const now = new Date();
      const isExpired = expiryDate < now;
      expiryLabel = isExpired ? "Expired On:" : "Expires On:";
      expiryDisplay = expiryDate.toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    }
  }

  return (
    <Container fluid className=" px-2">
      <Card className="border" style={{ borderRadius: "5px" }}>
        <Card.Body className="p-4">
          <Row className="d-flex align-items-start justify-content-between flex-wrap">
            <Col xs="auto" className="flex-grow-1">
              <Form.Group>
                <Form.Label className="" style={{ fontSize: "18px", fontWeight: 600 }}s>Current Plan</Form.Label>
              </Form.Group>
            </Col>
            <Col xs="auto" className="text-end">
              <Form.Group>
                <Badge bg="success" className="fs-4 bold">{currentPlan?.plan?.label}</Badge>
              </Form.Group>
            </Col>
          </Row>
          <Row className="">
            <Col xs={12}>
              <Form.Group className="d-flex align-items-center">
                <Form.Label className="" style={{ fontSize: "14px", fontWeight: 600 }}>No of Allowed Users:</Form.Label>
                <Form.Label className="ms-2">{currentPlan?.subscription?.max_users}</Form.Label>
              </Form.Group>
            </Col>
          </Row>
          {productLabel && (
            <Row className="">
              <Col xs={12}>
                <Form.Group className="d-flex align-items-center">
                  <Form.Label className="" style={{ fontSize: "14px", fontWeight: 600 }}>Product:</Form.Label>
                  <Form.Label className="ms-2">{productLabel}</Form.Label>
                </Form.Group>
              </Col>
            </Row>
          )}
          <Row className="">
            <Col xs={12}>
              <Form.Group className="d-flex align-items-center">
                <Form.Label className="" style={{ fontSize: "14px", fontWeight: 600 }}>Active Users:</Form.Label>
                <Form.Label className="ms-2">{currentPlan?.subscription?.current_users}</Form.Label>
              </Form.Group>
            </Col>
          </Row>
          <Row className="">
            <Col xs={12}>
              <Form.Group className="d-flex align-items-center">
                <Form.Label className="" style={{ fontSize: "14px", fontWeight: 600 }}>Accessible on:</Form.Label>
                <Form.Label className="ms-2">
                  {hasDesktopAccess ? "Android, IOS & Desktop" : "Android & IOS"}
                </Form.Label>
              </Form.Group>
            </Col>
          </Row>
          {expiryDisplay && (
            <Row className="">
              <Col xs={12}>
                <Form.Group className="d-flex align-items-center">
                  <Form.Label className="" style={{ fontSize: "14px", fontWeight: 600 }}>{expiryLabel}</Form.Label>
                  <Form.Label className="ms-2">{expiryDisplay}</Form.Label>
                </Form.Group>
              </Col>
            </Row>
          )}
          <Row className="mt-2">
            <Col xs="auto" className="mb-2">
              <Button variant="outline-primary" onClick={() => navigate("/plan/billing/change-plan/")}>
                Change Plan
              </Button>
            </Col>
            {currentPlan?.plan?.is_trial !== 1 && currentPlan?.plan?.label !== "Free" && (
              <Col xs="auto" className="mb-2">
                <Button
                  variant="outline-light"
                  style={{ border: "0.5px solid #ddd" }}
                  onClick={() => navigate("/plan/billing/manage-addons")}
                >
                  Manage Add-ons
                </Button>
              </Col>
            )}
          </Row>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default CurrentPlanBlock;
